import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-i-small', 'IconLetterISmall', [["path",{"d":"M12 8v8","key":"svg-0"}]]);